export default __webpack_public_path__ + "d9af31af9f3ad04e78a238461bd052ed.png";